import { Button, Checkbox, Form, Input, Radio, Space, Typography } from "antd";
import { PlusCircle, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export const MultipleChoicesQuestion = () => {
  const {t} = useTranslation();
  return (
    <>
      <Form.Item noStyle shouldUpdate={(prev, cur) => prev.answers !== cur.answers}>
        {({ getFieldValue }) => {
          const answers = getFieldValue(["answers"]) || [];
          const hasAtLeastOneCorrect = answers.some((a: any) => a && a.isCorrect);
          if (hasAtLeastOneCorrect) return null;
          return (
            <div style={{ marginBottom: 8 }}>
              <Typography.Text strong type="warning">
                {t("forms.questions.oneAnswerCorrect")}
              </Typography.Text>
            </div>
          );
        }}
      </Form.Item>

      <Form.List name={["answers"]} initialValue={[{}]}>
        {(fields, { add, remove }) => (
          <Radio.Group style={{ width: "100%" }}>
            {fields.map(({ key, name, ...restField }) => {
              return (
                <Space
                  className="question-type-form"
                  key={key}
                  style={{ display: "flex", marginBottom: 8 }}
                  align="baseline"
                >
                  <Form.Item
                    noStyle
                    initialValue={false}
                    {...restField}
                    name={[name, "isCorrect"]}
                    valuePropName="checked"
                  >
                    <Checkbox value={key} />
                  </Form.Item>

                  <Form.Item
                    style={{ width: "100%" }}
                    {...restField}
                    name={[name, "value"]}
                    rules={[
                      { required: true, message: t("forms.questions.inputPlaceholder") },
                    ]}
                  >
                    <Input placeholder= {t("forms.questions.inputPlaceholder")} />
                  </Form.Item>
                  <Button
                    icon={<Trash2 />}
                    danger
                    onClick={() => remove(name)}
                  />
                </Space>
              );
            })}
            <Form.Item noStyle>
              <Button
                type="dashed"
                icon={<PlusCircle />}
                block
                onClick={() => add()}
              >
                {t("forms.questions.addAnswer")}
              </Button>
            </Form.Item>
          </Radio.Group>
        )}
      </Form.List>

      {/* Hidden validator: ensure at least one correct answer is selected */}
      <Form.Item noStyle shouldUpdate={(prev, cur) => prev.answers !== cur.answers}>
        {() => (
          <Form.Item
            name={["answers"]}
            style={{ display: "none" }}
            rules={[
              {
                validator: (_, value) => {
                  const list = Array.isArray(value) ? value : [];
                  return list.some((answer) => answer && answer.isCorrect)
                    ? Promise.resolve()
                    : Promise.reject(new Error(t("forms.questions.selectAtLeastOneCorrect")));
                },
              },
            ]}
          >
            <span />
          </Form.Item>
        )}
      </Form.Item>
    </>
  );
};
